// extracted by mini-css-extract-plugin
export var container = "textBlock-module--container--W3ZbE";